export const handleWarning = async ({ condition, warningDispatch, action }) => {
  try {
    if (condition) {
      await warningDispatch();
    }
    await action();
  } catch (e) {
    if (e.result !== "cancel") {
      throw e;
    }
  }
};
